<div mat-dialog-title>{{ 'dialogs.stayOnPage.title' | translate }}</div>
<div mat-dialog-content>{{ 'dialogs.stayOnPage.content' | translate }}</div>
<div mat-dialog-actions>
	<button mat-raised-button color="warn" class="confirm-button" (click)="onClickConfirm()">
		{{ 'dialogs.stayOnPage.leaveWithoutSaving' | translate }}
	</button>
	<button mat-raised-button color="primary" (click)="onClickCancel()">{{ 'dialogs.stayOnPage.stayOnPage' | translate }}</button>
</div>
